import makeApiCall from "../master/axiosIndex";

const paymentsApis = {
  listPayment: (params: any) =>
    makeApiCall({
      url: "/ra-bill/payments/list",
      method: "get",
      params,
    }),
  paymentById: (paymentId: any) =>
    makeApiCall({
      url: `/ra-bill/payments/id/${paymentId}`,
      method: "get",
    }),
};

export default paymentsApis;
